import ActionButton from "../ActionButton/ActionButton";
import WebIcon from "../../Icon-SVG/WebIcon";

// The "Visit Page" action of the PhishBox and phishing email tables.
const SandboxVisitButton = ({ onClick, disabled = false, children = "Visit Page" }) => (
  <ActionButton
    icon={<WebIcon width={14} height={14} color="currentColor" />}
    title="Open this URL through the PhishBox sandbox"
    onClick={onClick}
    disabled={disabled}>
    {children}
  </ActionButton>
);

export default SandboxVisitButton;
